<section class="login-page">
  <header>
    <h1 mdcHeadline1>Kinologg</h1>
  </header>

  <form *ngIf="!showResetPwd" [formGroup]="login" (ngSubmit)="logIn()">
    <section class="login-form">
      <mdc-text-field
        outlined
        label="Brukernavn"
        formControlName="username"
      ></mdc-text-field>
      <mdc-text-field
        type="password"
        outlined
        label="Passord"
        formControlName="password"
      ></mdc-text-field>
      <div *ngIf="show2FA && qrCodeImage">
        <h2 mdcHeadline5>To-faktor kreves</h2>
        <p>
          Scan QR-koden med din autentiseringsapp for å aktivere to-faktor. Hvis
          du ikke har en autentiseringsapp, kan du for eksempel bruke:
        </p>
        <ul>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
              >Google Authenticator</a
            >
          </li>
          <li>
            <a
              href="https://www.microsoft.com/en-us/security/mobile-authenticator-app"
              >Microsoft Authenticator</a
            >
          </li>
        </ul>
        <img [src]="qrCodeImage" alt="QR-kode for to-faktor" />
        <p>Skriv deretter inn koden fra appen for å fullføre innlogging:</p>
      </div>
      <mdc-text-field
        *ngIf="show2FA"
        type="text"
        outlined
        label="To-faktor kode"
        formControlName="twofactorcode"
      ></mdc-text-field>
      <div class="login__actions">
        <button
          mdc-button
          [disabled]="show2FA && !login.value.twofactorcode"
          type="submit"
          primary
          raised
        >
          {{ buttonText }}
        </button>
      </div>
      <div class="form-error"></div>
    </section>
  </form>

  <div
    class="password-reset"
    style="display: flex; justify-content: space-between"
  >
    <button mdc-button class="button-no-bg" (click)="toggleReset()">
      {{ showResetPwd ? "Tilbake" : "Glemt Passord" }}
    </button>
    <button mdc-button class="button-no-bg" (click)="reloadPage()">
      Start på nytt
    </button>
  </div>

  <section *ngIf="showResetPwd && !resetConfirm">
    <form [formGroup]="reset" (ngSubmit)="resetPwd()">
      <mdc-text-field
        type="text"
        outlined
        label="Brukernavn"
        formControlName="username"
      ></mdc-text-field>
      <div class="login__actions">
        <button
          mdc-button
          type="submit"
          primary
          raised
          [disabled]="!reset.valid"
        >
          Send reset-passord lenke
        </button>
      </div>
      <div class="form-error"></div>
    </form>
  </section>
  <section *ngIf="resetConfirm">
    <h3>
      Epost med instruksjoner sendt hvis brukernavnet er gyldig. Sjekk
      spamfolder osv.
    </h3>
  </section>

  <a mdcBody1 class="link-for-spillested" routerLink="/plan-spillested"
    >Oversikt for spillesteder</a
  >
</section>
